var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M46.91 14.306L36.14 36.931a.607.607 0 01-.813.289l-2.445-1.171v-7.843l3.978 1.905 7.065-14.836L21.331 4.447l-4.164 8.751h-3.09l5.672-11.91a.606.606 0 01.812-.282l26.062 12.49a.604.604 0 01.287.81zm-15.839.938V40.32a.612.612 0 01-.611.611H1.578a.614.614 0 01-.611-.611V15.244c0-.335.276-.608.611-.608h28.883c.337 0 .611.273.61.608zm-2.278 2.165H3.755v16.445h4.361s3.192-12.786 6.487-9.481c3.294 3.306 4.489 9.481 4.489 9.481s1.166-5.472 3.5-6.07c1.992-.513 3.304 3.327 4.37 6.07h1.831V17.409zm-4.448 5.156a4.077 4.077 0 01-1.574-.304 6.61 6.61 0 01-1.269.124c-1.575 0-2.849-.512-2.849-1.143 0-.528.907-.971 2.126-1.1a.972.972 0 01.961-.874h.395c.267 0 .507.108.687.284a3.995 3.995 0 011.523-.284c1.508 0 2.727.739 2.727 1.648 0 .911-1.219 1.649-2.727 1.649zm-16.549.423a2.048 2.048 0 01-2.044-2.05c0-1.132.915-2.049 2.044-2.049 1.128 0 2.042.917 2.042 2.049 0 1.131-.914 2.05-2.042 2.05z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleri);
export default __webpack_public_path__ + "static/media/galleri.b0ba1f85.svg";
export { ForwardRef as ReactComponent };